import {REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS} from "../../../middlewares/api/actions";
import {
  getArtefactFromSdmxJsonStructure,
  getSdmxStructuresFromSdmxJson,
  SDMX_JSON_MSD_LIST_KEY
} from "../../../utils/sdmxJson";
import {
  MSDS_AGENCIES_READ,
  MSDS_LIST_MSDS_READ,
  MSDS_MSD_CLONE_CHANGE,
  MSDS_MSD_CLONE_HIDE,
  MSDS_MSD_CLONE_SHOW,
  MSDS_MSD_CLONE_SUBMIT,
  MSDS_MSD_DELETE,
  MSDS_MSD_DETAIL_CHANGE,
  MSDS_MSD_DETAIL_HIDE,
  MSDS_MSD_DETAIL_READ,
  MSDS_MSD_DETAIL_SHOW,
  MSDS_MSD_DETAIL_SUBMIT,
  MSDS_MSD_DOWNLOAD,
  MSDS_MSD_DOWNLOAD_CHANGE,
  MSDS_MSD_DOWNLOAD_HIDE,
  MSDS_MSD_DOWNLOAD_SHOW,
  MSDS_MSD_EXPORT_CHANGE,
  MSDS_MSD_EXPORT_HIDE,
  MSDS_MSD_EXPORT_REPORT_HIDE,
  MSDS_MSD_EXPORT_SHOW,
  MSDS_MSD_EXPORT_SUBMIT,
  MSDS_MSD_EXPORT_LIST_SHOW,
  MSDS_MSD_PARENTS_AND_CHILDREN_HIDE,
  MSDS_MSD_PARENTS_AND_CHILDREN_READ,
  MSDS_SELECTED_MSDS_DELETE
} from "./actions";
import _ from "lodash";
import {getCurrentNodeConfig} from "../../../middlewares/current-node-config/middleware";
import {getCustomIsPresentationalFromAnnotations} from "../../../utils/referenceMetadata";
import {getCurrentUserPermissions} from "../../../middlewares/current-user-permissions/middleware";

const msdsReducer = (
  state = {
    msds: null,
    isVisible: false,
    msdTriplet: null,
    msd: null,
    agencies: null,
    allAgencies: null,
    downloadMsdTriplets: null,
    downloadMsdLang: null,
    downloadMsdParams: null,
    parentsAndChildren: null,
    cloneDestTriplet: null,
    msdExportSourceTriplet: null,
    msdExportDestination: null,
    msdExportReport: null
  },
  action
) => {
  switch (action.type) {
    case MSDS_MSD_DETAIL_SHOW:
      return {
        ...state,
        isVisible: true,
        msdTriplet: action.artefactTriplet
      };
    case MSDS_MSD_DETAIL_CHANGE:
      const msd = _.cloneDeep(state.msd);

      const customizer = (_, src, key) => {
        if (key === "annotations")
          return src;
        else {
          return undefined
        }
      };

      return {
        ...state,
        msd: _.mergeWith(msd, action.fields, customizer)
      };
    case MSDS_MSD_DETAIL_HIDE:
      return {
        ...state,
        isVisible: false,
        msd: null,
        msdTriplet: null,
        agencies: null
      };
    case MSDS_MSD_DOWNLOAD_SHOW:
      return {
        ...state,
        downloadMsdTriplets: action.artefactTriplets,
        downloadMsdLang: action.lang,
        downloadMsdParams: {
          format: null,
          references: false,
          compression: false,
          csvSeparator: ";",
          csvDelimiter: null,
          csvLanguage: null
        },
      };
      case MSDS_MSD_EXPORT_LIST_SHOW:
        return {
          ...state,
          downloadMsdTriplets: action.artefactTriplets,
          downloadMsdLang: action.lang,
          downloadMsdParams: {
            format: "csv",
            hideFormat: true,
            hideLanguage: true,
            references: false,
            compression: false,
            csvSeparator: ";",
            csvDelimiter: null,
            csvLanguage: null
          },
        };
    case MSDS_MSD_DOWNLOAD_HIDE:
      return {
        ...state,
        downloadMsdTriplets: null,
        downloadMsdLang: null,
        downloadMsdParams: null
      };
    case MSDS_MSD_DOWNLOAD_CHANGE:
      const downloadMsdParams = _.cloneDeep(state.downloadMsdParams);
      return {
        ...state,
        downloadMsdParams: _.merge(downloadMsdParams, action.fields)
      };
    case MSDS_MSD_PARENTS_AND_CHILDREN_HIDE:
      return {
        ...state,
        parentsAndChildren: null
      };
    case MSDS_MSD_CLONE_SHOW:
      const srcVersionArr = action.srcTriplet.version.split(".");
      const destVersionArr = srcVersionArr.map((num, index) =>
        index === srcVersionArr.length - 1
          ? Number(num) + 1
          : num
      );

      return {
        ...state,
        cloneDestTriplet: {
          ...action.srcTriplet,
          version: destVersionArr.join(".")
        },
        msdTriplet: state.msdTriplet ? state.msdTriplet : action.srcTriplet,
      };
    case MSDS_MSD_CLONE_HIDE:
      return {
        ...state,
        cloneDestTriplet: null,
        msd: state.isVisible ? state.msd : null,
        msdTriplet: state.isVisible ? state.msdTriplet : null,
        agencies: state.isVisible ? state.agencies : null,
        allAgencies: state.isVisible ? state.allAgencies : null
      };
    case MSDS_MSD_CLONE_CHANGE:

      const cloneDestTriplet = _.cloneDeep(state.cloneDestTriplet);

      return {
        ...state,
        cloneDestTriplet: _.merge(cloneDestTriplet, action.fields)
      };
    case MSDS_MSD_EXPORT_SHOW:
      return {
        ...state,
        msdExportSourceTriplet: action.sourceTriplet,
        msdExportDestination: {
          endpoint: null,
          username: null,
          password: null,
          id: action.sourceTriplet.id,
          agencyID: action.sourceTriplet.agencyID,
          version: action.sourceTriplet.version
        }
      };
    case MSDS_MSD_EXPORT_HIDE:
      return {
        ...state,
        msdExportSourceTriplet: null,
        msdExportDestination: null,
        agencies: state.isVisible ? state.agencies : null,
        allAgencies: state.isVisible ? state.allAgencies : null
      };
    case MSDS_MSD_EXPORT_CHANGE:

      const msdExportDestination = _.cloneDeep(state.msdExportDestination);
      _.merge(msdExportDestination, action.fields);

      return {
        ...state,
        msdExportDestination
      };
    case MSDS_MSD_EXPORT_REPORT_HIDE:
      return {
        ...state,
        msdExportReport: null
      };
    case REQUEST_START:
      switch (action.label) {
        case MSDS_LIST_MSDS_READ:
          return {
            ...state,
            msds: null
          };
        default:
          return state;
      }
    case REQUEST_SUCCESS:
      switch (action.label) {
        case MSDS_LIST_MSDS_READ:
          return {
            ...state,
            msds: getSdmxStructuresFromSdmxJson(action.response).map(artefact =>
              getArtefactFromSdmxJsonStructure(artefact, getCurrentNodeConfig(action).annotations))
          };
        case MSDS_AGENCIES_READ:
          return {
            ...state,
            agencies: _.pickBy(action.response, (_, agencyID) => !action.allowedAgencies || action.allowedAgencies.includes(agencyID)),
            allAgencies: action.response,
          };
        case MSDS_MSD_DETAIL_READ:

          const userPermissions = getCurrentUserPermissions(action);
          const customNoneIsAutoAnnotation = userPermissions && userPermissions.rules.includes("CanManageWorkingAnnotation")
            ? () => false
            : undefined;

          const msd = getArtefactFromSdmxJsonStructure(
            getSdmxStructuresFromSdmxJson(action.response, SDMX_JSON_MSD_LIST_KEY)[0],
            getCurrentNodeConfig(action).annotations,
            customNoneIsAutoAnnotation
          );

          return {
            ...state,
            msd: {
              ...msd,
              customIsPresentational: getCustomIsPresentationalFromAnnotations(msd, getCurrentNodeConfig(action).annotations)
            }
          };
        case MSDS_MSD_DETAIL_SUBMIT:
          return {
            ...state,
            msd: null,
            msds: null
          };
        case MSDS_MSD_DELETE:
          return {
            ...state,
            msds: null
          };
        case MSDS_SELECTED_MSDS_DELETE:
          return {
            ...state,
            msds: null
          };
        case MSDS_MSD_DOWNLOAD:
          return {
            ...state,
            downloadMsdTriplets: null,
            downloadMsdLang: null,
            downloadMsdParams: null
          };
        case MSDS_MSD_PARENTS_AND_CHILDREN_READ:
          return {
            ...state,
            parentsAndChildren: action.response
          };
        case MSDS_MSD_EXPORT_SUBMIT:
          return {
            ...state,
            msdExportSourceTriplet: null,
            msdExportDestination: null,
            msdExportReport: action.response.itemsMessage,
            agencies: state.isVisible ? state.agencies : null,
            allAgencies: state.isVisible ? state.allAgencies : null
          };
        case MSDS_MSD_CLONE_SUBMIT:
          return {
            ...state,
            msds: null,
            cloneDestTriplet: null,
            msd: state.isVisible ? state.msd : null,
            msdTriplet: state.isVisible ? state.msdTriplet : null,
            agencies: state.isVisible ? state.agencies : null,
            allAgencies: state.isVisible ? state.allAgencies : null
          };
        default:
          return state;
      }
    case REQUEST_ERROR:
      switch (action.label) {
        case MSDS_SELECTED_MSDS_DELETE:
          return {
            ...state,
            msds: null
          };
        default:
          return state;
      }
    default:
      return state;
  }
};

export default msdsReducer;
